import axios from 'axios';

// Relative base URL works in both development (via CRA proxy) and
// production (Express serves the React build on the same origin).
const BASE_URL = '/api/v1';

export default axios.create({
    baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});
